<template>
  <div class="this-week">
    <food-menu :isThisWeek="isThisWeek"></food-menu>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import FoodMenu from '@/components/food-mune.vue'
export default {
  components: {
    FoodMenu
  },

  data() {
    return {
      isThisWeek: 1
    }
  },

  created() {
    config()
  },

  methods: {
  }
}
</script>

<style lang='scss'>
.this-week {
  // flex: 1;
  // display: flex;
  // flex-direction: column;
}
</style>

